export const UTM_PARAMETER_NAMES = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
] as const

export interface UtmValues {
  source: string
  medium: string
  campaign: string
  term?: string
  content?: string
}

export type UtmValidationError =
  | 'empty-url'
  | 'invalid-url'
  | 'unsupported-protocol'
  | 'missing-required-fields'

export class UtmBuilderError extends Error {
  constructor(public readonly code: UtmValidationError) {
    super(code)
    this.name = 'UtmBuilderError'
  }
}

export function buildUtmUrl(baseUrl: string, values: UtmValues): string {
  const trimmedUrl = baseUrl.trim()
  if (!trimmedUrl) throw new UtmBuilderError('empty-url')

  let url: URL
  try {
    url = new URL(trimmedUrl)
  } catch {
    throw new UtmBuilderError('invalid-url')
  }

  if (url.protocol !== 'http:' && url.protocol !== 'https:') {
    throw new UtmBuilderError('unsupported-protocol')
  }

  const source = values.source.trim()
  const medium = values.medium.trim()
  const campaign = values.campaign.trim()
  if (!source || !medium || !campaign) {
    throw new UtmBuilderError('missing-required-fields')
  }

  for (const name of UTM_PARAMETER_NAMES) url.searchParams.delete(name)
  url.searchParams.append('utm_source', source)
  url.searchParams.append('utm_medium', medium)
  url.searchParams.append('utm_campaign', campaign)

  const term = values.term?.trim()
  const content = values.content?.trim()
  if (term) url.searchParams.append('utm_term', term)
  if (content) url.searchParams.append('utm_content', content)

  return url.toString()
}
